import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'app-pagination-table',
  templateUrl: './pagination-table.component.html',
  styleUrls: ['./pagination-table.component.css']
})
export class PaginationTableComponent implements OnInit, OnChanges, OnDestroy {

  constructor() { 
  }

  public ngOnDestroy(): void {
    // this.changePage.unsubscribe();
  }

  @Input() totalPages: number = 0;
  @Input() currentPage: number = 1;
  @Output() changePage = new EventEmitter<number>();


  pages: Array<any> = [];
  actualPage: number = 1;
  totalPage: number = 1;
  maxPages: number = 5;

  ngOnInit() {
     
  }

  ngOnChanges() {
 
    this.totalPage = this.totalPages;
    this.actualPage = this.currentPage;

    //Buscamos el primer y último elemento
    const firstElemet = this.getFisrtElement();
    const lastElement = firstElemet <= 1 ? this.maxPages : firstElemet + this.maxPages; 
    this.generatePages(firstElemet, lastElement);
  }



  private getFisrtElement(): number {
    if (this.actualPage <= this.maxPages) {
      return 1;
    }
    return (this.actualPage - this.maxPages) + 1;
  }



  private generatePages(firstElemet: number, lastElement: number) {
    this.pages = [];
    //Creamos el arreglo de páginas
    for (let i = firstElemet; i <= lastElement; i++) { 
      if (i > this.totalPage) {
        break;
      }
      this.pages.push({
        value: i - 1,
        label: i,
        active: i === this.currentPage
      });
    } 
  }

  public selectPage(page: number) {
    this.changePage.emit(page);
  }


  public nextPage() {
    const page = this.actualPage + 1;
    if (page > this.totalPage) {
      return;
    }
    this.changePage.emit(page);
  }
  public previousPage() {
    const page = this.actualPage - 1;
    if (page < 1) {
      return;
    }
    this.changePage.emit(page);
  }

}
